import {defineComponent} from "vue";
import {DpModuleEnum} from "@/api/enums/dp-module-enum";
import {EnumClassNameCpcEnum} from "@/models/enum/EnumClassNameCpcEnum";
import {EnumClassNameAuthEnum} from "@/models/enum/EnumClassNameAuthEnum";
import {EnumClassNameOrderEnum} from "@/models/enum/EnumClassNameOrderEnum";
import {EnumClassNamePlanEnum} from "@/models/enum/EnumClassNamePlanEnum";

export const NotificationTemplateMixin = defineComponent({
    methods: {
        getNotificationTypeEnum(moduleCode: string): string {
            switch (moduleCode) {
                case DpModuleEnum.PLAN:
                    return EnumClassNamePlanEnum.NOTIFICATION_TYPE;
                case DpModuleEnum.AUTH:
                    return EnumClassNameAuthEnum.NOTIFICATION_TYPE;
                case DpModuleEnum.CPC:
                    return EnumClassNameCpcEnum.NOTIFICATION_TYPE;
                case DpModuleEnum.ORDER:
                    return EnumClassNameOrderEnum.NOTIFICATION_TYPE;
                default:
                    throw new Error('No notification types exist for module code: ' + moduleCode);
            }
        }
    }
});
